/**
 * Below-fold main min-heights so sticky footer does not park in the Lighthouse
 * viewport while lazy route shells resolve (PSI CLS attributed to footer ~0.4+).
 */
export const PUBLIC_SHELL_MIN_HEIGHT = { xs: 2200, md: 2600 } as const;

/** Shared reserved height for in-flow APT / AdSense slot placeholders (CLS). */
export const AD_SLOT_MIN_HEIGHT_PX = 120;
